export const UPDATE_GRID_TOTAL_LIMIT = 'UPDATE_GRID_TOTAL_LIMIT';

export function updateGridSettings(limit) {
  return {
    type: UPDATE_GRID_TOTAL_LIMIT,
    gridTotalLimit: limit
  };
}
